<template>
    <div>
        <!-- <input v-model="email" placeholder="E-mail" /> -->
        <button @click="loginUser">Přihlásit</button>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import { PublicClientApplication } from '@azure/msal-browser';

    export default {
        name: 'Login',
        data() {
            return {
                email: ''
            }
        },
        methods: {
            async loginUser() {
                const msalConfig = {
                    auth: {
                        clientId: process.env.VUE_APP_MSAL_CLIENTID,
                        authority: process.env.VUE_APP_MSAL_AUTHORITY
                    },
                    cache: {
                        cacheLocation: 'localStorage',
                        storeAuthStateInCookie: false
                    }
                }

                const loginRequest = {
                    scopes: ["User.Read"]
                };
                
                const msalInstance = new PublicClientApplication(msalConfig);

                const accounts = msalInstance.getAllAccounts()
                if (accounts.length == 0) {
                    await msalInstance.loginPopup(loginRequest)
                    .then(() => { 
                        this.email = msalInstance.getAllAccounts()[0].username
                    })
                    .catch(error => {
                        console.log('Authentication error: ', error)
                    })
                }
                else {
                    this.email = accounts[0].username
                }

                this.$progress.start()
                api.getUserByEmail(this.email)
                
                .then(response => {
                    this.$progress.finish()
                    this.$emit('setLoggedUser', response.data)
                })
                .catch(error => { 
                    this.$progress.finish()
                    console.log('Error: ', error)
                })
            }
        }
    }
</script>